import { useEffect, useState } from 'react';
import { updateSignatureLayout } from '../services/settingsService';
import {
  getCompanySignatureLayout,
  SIGNATURE_LAYOUT_DEFAULTS
} from '../utils/signatureLayout';

export default function useDocumentSignatureLayout(documentType, company, setCompany) {
  const [signatureLayout, setSignatureLayout] = useState({
    ...(SIGNATURE_LAYOUT_DEFAULTS[documentType] || SIGNATURE_LAYOUT_DEFAULTS.receipt)
  });
  const [signatureLayoutSaving, setSignatureLayoutSaving] = useState(false);

  useEffect(() => {
    if (company) {
      setSignatureLayout(getCompanySignatureLayout(company, documentType));
    }
  }, [company, documentType]);

  const saveSignatureLayout = async () => {
    setSignatureLayoutSaving(true);
    try {
      const response = await updateSignatureLayout(documentType, signatureLayout);
      const layouts = response.data?.data?.signature_layout;

      if (layouts && typeof setCompany === 'function') {
        setCompany(current => ({ ...(current || {}), signature_layout: layouts }));
      }

      return response;
    } finally {
      setSignatureLayoutSaving(false);
    }
  };

  return {
    signatureLayout,
    setSignatureLayout,
    signatureLayoutSaving,
    saveSignatureLayout
  };
}
